<template>
  <div>
    <div v-if="isUnableToSendSingleAppointment">
      <v-alert class="red lighten-5 mt-2 mb-6">
        <p class="body-2 red--text mb-2">
          {{ $t('appointment.confirmAppointment.sendRejectedEmailModal.unableToSendEmail') }}
        </p>
        <v-chip class="mr-1 mb-1 red" x-small>
          <span class="white--text">
            {{ appointmentCode }}
          </span>
        </v-chip>
        <p class="caption red--text mt-2">
          {{ $t('appointment.confirmAppointment.sendRejectedEmailModal.unableToSendEmailTip') }}
        </p>
      </v-alert>
    </div>
    <div v-else>
      <p class="body-2 mb-2">
        {{ $t('appointment.confirmAppointment.sendRejectedEmailModal.sendEmailMessageSingle')}}
      </p>
      <v-chip class="mr-1 mb-1 orange" x-small>
        <span class="white--text">
          {{ appointmentCode }}
        </span>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBulkSendRejectedEmailSingleAppointment',

  props: {
    appointmentAbleToSend: {
      type: Array,
      required: false,
      default: () => [],
    },

    appointmentUnableToSend: {
      type: Array,
      required: false,
      default: () => [],
    },

    isUnableToSendSingleAppointment: {
      type: Boolean,
      required: false,
    },
  },

  watch: {
    appointmentUnableToSend(value) {
      if (value.length <= 0) return
      this.appointmentCode = value[0]?.code
    },
  },

  computed: {
    appointmentCode: {
      get() {
        return this.appointmentUnableToSend.length > 0
          ? this.appointmentUnableToSend[0]?.code
          : this.appointmentAbleToSend[0]?.code
      },
      set(value) {
        return value
      },
    }
  },
}
</script>
